import MicroModal from "micromodal";

export function drawer() {
  MicroModal.init();

  const buttons = document.querySelectorAll(".js-drawerButton");
  const header = document.getElementById("js-header");

  const closeDrawer = (button, modalId) => {
    button.setAttribute("aria-expanded", "false");
    MicroModal.close(modalId, {
      awaitCloseAnimation: true,
    });
    header.classList.remove("is-open");
  };

  buttons.forEach((button) => {
    const modalEl = button.nextElementSibling;
    const modalId = modalEl.id;

    button.addEventListener("click", () => {
      const currentAriaExpanded = button.getAttribute("aria-expanded");

      if (currentAriaExpanded === "false") {
        button.setAttribute("aria-expanded", "true");
        MicroModal.show(modalId, {
          disableScroll: true, // ページスクロールを無効に
          awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
        });
        header.classList.add("is-open");
      } else {
        closeDrawer(button, modalId);
      }
    });

    // 同一ページ内アンカー（#stage 等）ではページ遷移しないため、リンククリック時に明示的に閉じる
    modalEl.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        if (button.getAttribute("aria-expanded") === "true") {
          closeDrawer(button, modalId);
        }
      });
    });
  });
}